import { render } from "./PhysicalPartList.vue?vue&type=template&id=1c466602&scoped=true"
import script from "./PhysicalPartList.vue?vue&type=script&lang=js"
export * from "./PhysicalPartList.vue?vue&type=script&lang=js"

import "./PhysicalPartList.vue?vue&type=style&index=0&id=1c466602&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c466602"]])

export default __exports__